export const NavigationPath = {
  LOGIN_ROUTE: "/login",
  RESET_PASSWORD_ROUTE: "/reset-password",
  DASHBOARD_ROUTE: "/dashboard",
  SUPPLIERS_ROUTE: "/suppliers",
  EDIT_SUPPLIER: "/supplier/:id",
  ADD_SUPPLIER: "/add-supplier",
  BRANDS_ROUTE: "/brands",
  ADD_BRAND_ROUTE: "/add-brand",
  EDIT_BRAND_ROUTE: "/brands/:id",
  USERS_ROUTE: "/users",
  REGISTER_USER: "/register-user",
  EDIT_USER: "/user/:id",
  OFFERS_ROUTE: "/offers",
  EDIT_OFFER: "/offer/:id",
  WEB_CALCULATOR_ROUTE: "/web-calculator",
  OFFER_REQUESTS_ROUTE: "/offer-requests",
  ADD_OFFER_REQUEST_ROUTE: "/add-offer-request",
  OFFER_RESPONSES_ROUTE: "/offer-responses",
  SINGLE_OFFER_RESPONSES_ROUTE: "/offer-request/:offerRequestId/responses",
  SINGLE_RESPONSE_ROUTE: "/offer-response/:offerResponseId",

  AFIP_ROUTE: "/afip",
  DOCUMENTACION_ROUTE: "/documentation",
  SCORE_ROUTE: "/score",
  COMMISSION_ROUTE: "/commission",
};

export const RoleOptionsValues = {
  LEASING_ADMIN: "Leasing admin",
  LEASING_KORISNIK: "Leasing korisnik",
  DOBAVLJAC_ADMIN: "Dobavljač admin",
  DOBAVLJAC_KORISNIK: "Dobavljač korisnik",
};

export const locations = {
  federacijaBiH: "Federacija BiH",
  republikaSrpska: "Republika Srpska",
  brckoDistrikt: "Brčko Distrikt",
};

export const clientType = [{ value: "Pravno lice" }, { value: "Fizičko lice" }];
export const leaseType = [
  { value: "Finansijski leasing" },
  { value: "Operativni leasing" },
];
export const currency = [{ value: "BAM" }, { value: "EUR" }];
export const calculationType = [
  { value: "Standardni" },
  { value: "Trećine" },
  { value: "Četvrtine" },
];
export const assetAge = [{ value: "Novo" }, { value: "Polovno" }];

const currentYear = new Date().getFullYear();

export const manufacturingYear7 = [
  { value: `${currentYear}` },
  { value: `${currentYear - 1}` },
  { value: `${currentYear - 2}` },
  { value: `${currentYear - 3}` },
  { value: `${currentYear - 4}` },
  { value: `${currentYear - 5}` },
  { value: `${currentYear - 6}` },
];
export const manufacturingYear9 = [
  { value: `${currentYear}` },
  { value: `${currentYear - 1}` },
  { value: `${currentYear - 2}` },
  { value: `${currentYear - 3}` },
  { value: `${currentYear - 4}` },
  { value: `${currentYear - 5}` },
  { value: `${currentYear - 6}` },
  { value: `${currentYear - 7}` },
  { value: `${currentYear - 8}` },
];
export const manufacturingYear11 = [
  { value: `${currentYear}` },
  { value: `${currentYear - 1}` },
  { value: `${currentYear - 2}` },
  { value: `${currentYear - 3}` },
  { value: `${currentYear - 4}` },
  { value: `${currentYear - 5}` },
  { value: `${currentYear - 6}` },
  { value: `${currentYear - 7}` },
  { value: `${currentYear - 8}` },
  { value: `${currentYear - 9}` },
  { value: `${currentYear - 10}` },
  { value: `${currentYear - 11}` },
];

export const assetTypeFL = [
  { value: "Putnička vozila" },
  { value: "Laka dostavna vozila do 3,5 tone" },
  { value: "Teška teretna vozila preko 3,5 tone" },
  { value: "Građevinske mašine" },
  { value: "Quad/Motocikli" },
];
export const assetTypeOL = [
  { value: "Putnička vozila" },
  { value: "Laka dostavna vozila do 3,5 tone" },
  { value: "Teška teretna vozila preko 3,5 tone" },
];
export const durationFL = [
  { value: "1" },
  { value: "2" },
  { value: "3" },
  { value: "4" },
  { value: "5" },
  { value: "6" },
  { value: "7" },
];
export const durationOL = [
  { value: "1" },
  { value: "2" },
  { value: "3" },
  { value: "4" },
];
export const duration8 = [
  { value: "1" },
  { value: "2" },
  { value: "3" },
  { value: "4" },
  { value: "5" },
  { value: "6" },
  { value: "7" },
  { value: "8" },
];
export const duration10 = [
  { value: "1" },
  { value: "2" },
  { value: "3" },
  { value: "4" },
  { value: "5" },
  { value: "6" },
  { value: "7" },
  { value: "8" },
  { value: "9" },
  { value: "10" },
];
export const duration12 = [
  { value: "1" },
  { value: "2" },
  { value: "3" },
  { value: "4" },
  { value: "5" },
  { value: "6" },
  { value: "7" },
  { value: "8" },
  { value: "9" },
  { value: "10" },
  { value: "11" },
  { value: "12" },
];
export const documentationType = {
  pravnaLica: "Pravna lica",
  fizičkaLica: "Fizička lica",
  informacijeoObradiPodataka: "Informacije o obradi podataka",
};
